import React from 'react';
import { Space, Tag } from 'antd';
import { citationBadge } from '../utils/formatters';

export default function ClaimCitationLinks({ citations = [] }) {
  if (!citations.length) return null;

  return (
    <Space size={[4, 4]} wrap style={{ marginTop: 4 }}>
      {citations.slice(0, 4).map((citation) => {
        const badge = citationBadge(citation);
        const isExternal = citation.url && !String(citation.url).startsWith('local:');
        const label = citation.timestamp ? `${citation.title} · ${citation.timestamp}` : citation.title;
        const key = citation.citation_key || `${citation.source_id}-${citation.chunk_id}`;
        const tag = (
          <Tag color={badge.color} style={{ marginInlineEnd: 0, whiteSpace: 'normal' }}>
            {label}
          </Tag>
        );
        return isExternal ? (
          <a key={key} href={citation.url} target="_blank" rel="noopener noreferrer">
            {tag}
          </a>
        ) : (
          <span key={key}>{tag}</span>
        );
      })}
    </Space>
  );
}
